module.exports = __webpack_public_path__ + "static/media/do.6e5f7f9a.jpg";